import { render } from "./RulesTab.vue?vue&type=template&id=13b3cb05"
import script from "./RulesTab.vue?vue&type=script&lang=js"
export * from "./RulesTab.vue?vue&type=script&lang=js"
script.render = render

export default script